import { Edit, SimpleForm, TextInput } from 'react-admin';

export const EventEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" required />
        </SimpleForm>
    </Edit>
);